// Shared framer-motion variants for the LintelGrid landing page.

export const easeOut = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.85, ease: easeOut },
  },
};

export const stagger = (delay = 0, stagger = 0.12) => ({
  hidden: {},
  show: {
    transition: { delayChildren: delay, staggerChildren: stagger },
  },
});

// Masked line reveal (used in hero headline)
export const lineReveal = {
  hidden: { y: "110%" },
  show: {
    y: "0%",
    transition: { duration: 1, ease: easeOut },
  },
};

export const viewportOnce = { once: true, amount: 0.35 };
